const circle = document.getElementById("circle");
const main = document.querySelector(".content-wrapper");

main.addEventListener("mousemove", (e) => {
  circle.style.display = "block";
  const height = circle.offsetHeight;
  const width = circle.offsetWidth;

  setTimeout(() => {
    circle.style.left = `${e.pageX - width / 2}px`;
    circle.style.top = `${e.pageY - height / 2}px`;
  }, 20);
});

main.addEventListener("mouseleave", () => {
  // Hide the circle when mouse leaves the content wrapper
  circle.style.display = "none";
});

main.addEventListener("mouseenter", () => {
  // Show the circle when mouse enters the content wrapper
  circle.style.display = "block";
});

document.addEventListener("scroll", () => {
  // Hide the circle when mouse leaves the content wrapper
  circle.style.display = "none";
});
